import React from "react";
import { useTranslation } from "react-i18next";
import RegistrationPlate from "../common/RegistrationPlate";

const SV_MONTHS = ["jan", "feb", "mars", "apr", "maj", "juni", "juli", "aug", "sep", "okt", "nov", "dec"];
const EN_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "13 sep 2026, 06:10" — same pattern the mock-up's document uses everywhere
// a timestamp is shown (formatSignedAt in Klargo-Reference/src/lib/format.ts).
function formatDocDate(iso, english) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const months = english ? EN_MONTHS : SV_MONTHS;
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}, ${hh}:${mm}`;
}

// Document masthead — title, registration plate, vehicle name/year/type, who
// the deal is between, and the last-changed date — matching the mock-up's
// ds-doc-masthead grammar (see public.source.css).
export default function ContractMasthead({ t, regNo, vehicleDesignation, vehicleYears, vehicleType, sellerName, buyerName, lastChangedAt }) {
  const { i18n } = useTranslation();
  const english = i18n.resolvedLanguage?.startsWith("en");
  const meta = [vehicleYears, vehicleType].filter(Boolean).join(" · ");
  const changedText = formatDocDate(lastChangedAt, english);

  return (
    <header className="ds-doc-masthead">
      <h1 className="ds-doc-title">{t("agreement.masthead")}</h1>
      <div className="ds-doc-subject">
        {regNo && <RegistrationPlate value={regNo} size="object" />}
        <div className="min-w-0">
          {vehicleDesignation && <p className="ds-doc-subject-name">{vehicleDesignation}</p>}
          {meta && <p className="ds-doc-subject-meta">{meta}</p>}
        </div>
      </div>
      {(sellerName || buyerName) && (
        <ul className="ds-participants" aria-label={t("agreement.partiesTitle")}>
          <li className="ds-participant" data-party="seller">
            <span className="ds-participant-dot" aria-hidden="true" />
            <span className="ds-participant-name">{sellerName || "-"}</span>
            <span className="ds-participant-role">{t("role.seller")}</span>
          </li>
          <li className="ds-participant" data-party="buyer">
            <span className="ds-participant-dot" aria-hidden="true" />
            <span className="ds-participant-name">{buyerName || "-"}</span>
            <span className="ds-participant-role">{t("role.buyer")}</span>
          </li>
        </ul>
      )}
      {changedText && (
        <p className="ds-doc-masthead-meta">
          {t("agreement.lastChanged")} {changedText}
        </p>
      )}
    </header>
  );
}
